import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./OurMission.css";
import heroImg from "../TestImages/StockCake-Serene_Workspace_Sanctuary-2089290-standard.jpg";

function OurMission() {
  return (
    <div>
      {/* HERO / BANNER */}
      <div className="hero pt-4">
         <div
            className="hero-bg"
            style={{ backgroundImage: `url(${heroImg})` }}
          />
        <div className="hero-overlay" />
        <Container className="hero-inner pt-5">
          <h1 className="hero-title">Our Mission</h1>
          <p className="hero-subtitle">
            Designed by a sales leader. Engineered by family.
          </p>
        </Container>
      </div>

      {/* CONTENT */}
      <Container>
        <div className="mission-panel">
          <Row>
            {/* Lefts side */}
            <Col md={6}>
              <div className="mission-tagline">BUILT BY SIBLINGS</div>
              <h2 className="mission-headline">
                Two perspectives. One Stedi platform.
              </h2>

              <div className="pill-row">
                <span className="pill">Sales leadership</span>
                <span className="pill">Technical execution</span>
                <span className="pill">Clean systems</span>
              </div>

              <p className="mission-caption">
                <strong>Stedi</strong> is owned and built by siblings who bring
                two essential perspectives to the table: real-world sales
                leadership and technical execution.
              </p>
            </Col>

            {/* Right side*/}
            <Col md={6}>
              <div className="story-card-stack">
                <div className="story-card">
                  <div className="story-label">THE PROBLEM</div>
                  <div className="story-title">
                    Growing teams feel chaotic fast.
                  </div>
                  <div className="story-text">
                    Scattered tools, inconsistent systems, and “tribal knowledge”
                    slow teams down.
                  </div>
                </div>

                <div className="story-card">
                  <div className="story-label">THE INSIGHT</div>
                  <div className="story-title">Simple systems scale better.</div>
                  <div className="story-text">
                    Thoughtful engineering + clean design can turn chaos into
                    something intuitive and repeatable.
                  </div>
                </div>

                <div className="story-card">
                  <div className="story-label">THE MISSION</div>
                  <div className="story-title">
                    Build a platform for growing businesses.
                  </div>
                  <div className="story-text">
                    Every feature is shaped by collaboration, lived experience,
                    and the belief that simple systems create stronger teams.
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          {/* <hr className="mission-divider" />

          <Row className="g-3">
            <Col xs={12}>
              <h3 className="helps-title">Stedi helps teams</h3>
            </Col>

            <Col md={6} lg={3}>
              <div className="feature-tile">
                <div className="feature-icon">📌</div>
                <div className="feature-text">
                  Organize leads, contacts & follow-ups in one place
                </div>
              </div>
            </Col>

            <Col md={6} lg={3}>
              <div className="feature-tile">
                <div className="feature-icon">📚</div>
                <div className="feature-text">
                  Share resources and training with ease
                </div>
              </div>
            </Col>

            <Col md={6} lg={3}>
              <div className="feature-tile">
                <div className="feature-icon">📈</div>
                <div className="feature-text">
                  Track activity and progress without overwhelm
                </div>
              </div>
            </Col>

            <Col md={6} lg={3}>
              <div className="feature-tile">
                <div className="feature-icon">🌱</div>
                <div className="feature-text">
                  Build steady habits that compound over time
                </div>
              </div>
            </Col>
          </Row> */}
        </div>
      </Container>
    </div>
  );
}

export default OurMission;